import React from 'react';
import { Link as RouterLink, NavLink } from "react-router-dom";
function FooterComponent(props) {
  return (
    <footer id="footer" >
      <section className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-md-3 footer-contact">
              <h2 className="font-weight-bold codeium-head" style={{ color: "#003d7e" }}>Codeium</h2>
              <p>
                83, Shree Ji Park Colony,<br />
                    Mandsaur, Madhya Pradesh,<br />
                    PIN-458001 <br /><br />
                <strong>Phone:</strong> +91 9406608047<br />
                <strong>Email:</strong> contact@codeium.tech<br />
              </p>
            </div>
            <div className="col-6 col-md-3 footer-links">
              <h4>Navigate</h4>
              <ul>
                <li className="pb-0"><i className="bx bx-chevron-right"></i>
                  <a href="">
                    <NavLink to="/problems">Practice</NavLink>
                  </a>
                </li>
                <li className="pb-0"><i className="bx bx-chevron-right"></i>
                  <a href="">
                    <NavLink to="/contests">Compete</NavLink>
                  </a>
                </li>
                <li className="pb-0"><i className="bx bx-chevron-right"></i>
                  <a href="">
                    <NavLink to="/store">Store</NavLink>
                  </a>
                </li>
                <li className="pb-0"><i className="bx bx-chevron-right"></i>
                  <a href="">
                    <NavLink to="/leaderboard">Leaderboard</NavLink>
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-6 col-md-3 footer-links">
              <h4>More Info</h4>
              <ul>
                <li><i className="bx bx-chevron-right"></i><RouterLink to="/termsofservice">Terms of service</RouterLink></li>
                <li><i className="bx bx-chevron-right"></i><RouterLink to="/privacypolicy">Privacy policy</RouterLink></li>
                <li><i className="bx bx-chevron-right"></i><RouterLink to="/checkout/terms-and-conditions">Return and Refund Policy</RouterLink></li>
                <li><i className="bx bx-chevron-right"></i><RouterLink to="/checkout/shipping-policy">Shipping Policy</RouterLink></li>
                <li><i className="bx bx-chevron-right"></i><RouterLink to="/checkout/cancellation">Cancellation Policy</RouterLink></li>
              </ul>
            </div>
            <div className="col-md-3 footer-links ml-auto">
              <h4>Our Social Networks</h4>
              <p>Follow us at our Social handles to get all the updates.</p>
              <div className="social-links mt-3">
                <a href="https://twitter.com/AskCodeium" target="_blank" className="twitter"><i className="bx bxl-twitter"></i></a>
                <a href="https://www.facebook.com/AskCodeium" target="_blank" className="facebook"><i className="bx bxl-facebook"></i></a>
                <a href="https://www.instagram.com/askcodeium/" target="_blank" className="instagram"><i className="bx bxl-instagram"></i></a>
                <a href="https://www.linkedin.com/company/codeium" target="_blank" className="linkedin"><i className="bx bxl-linkedin"></i></a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );

}
export default FooterComponent;